module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('customer-documents', {
    attrs: {
      "customer": _vm.customer,
      "relations": _vm.relations
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('customer-services', {
    attrs: {
      "customer": _vm.customer,
      "source": _vm.sources.find(function (source) { return source.id === 'devis-b2b'; })
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('customer-services', {
    attrs: {
      "customer": _vm.customer,
      "source": _vm.sources.find(function (source) { return source.id === 'communication'; })
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dc26989"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Customers/ServiceAndDocuments.vue
// module id = 665
// module chunks = 1